"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplacementPanel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const Workspace_1 = require("../../Common/Workspace");
const Workspace_style_1 = require("../../Common/Workspace/Workspace.style");
const ColorReplacementPanel_1 = require("./ColorReplacementPanel");
function ReplacementPanel({ type, workspace, credentials, bucketName, objectKey, onAssetClick, replacement, options, labels: { colorReplacementTitle, chooseColorLabel, noAssetsReplacement }, cardButtons, companionUrl, }) {
    const { t } = (0, ui_common_translation_1.useTranslation)();
    const theme = (0, styled_components_1.useTheme)();
    const colorReplacementPanel = (0, react_1.useMemo)(() => {
        const colors = replacement.colors || [];
        return ((0, jsx_runtime_1.jsx)(ColorReplacementPanel_1.ColorReplacementPanel, { title: chooseColorLabel, colors: colors, onClick: onAssetClick }));
    }, [chooseColorLabel, onAssetClick, replacement.colors]);
    const assetReplacementPanel = (0, react_1.useMemo)(() => {
        if (!type) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)(Workspace_1.WorkspaceApp, { type: type, filter: {
                assets: replacement.assets || [],
                folders: replacement.folders || [],
            }, workspace: workspace, collection: Workspace_1.ResourceCollection.WORKSPACE, permissions: {
                assetManagement: false,
                search: false,
                drag: false,
            }, options: options, cardButtons: cardButtons, companionUrl: companionUrl, bucketName: bucketName, objectKey: objectKey, onAssetClick: onAssetClick, credentials: credentials }));
    }, [
        bucketName,
        cardButtons,
        companionUrl,
        credentials,
        objectKey,
        onAssetClick,
        options,
        replacement.assets,
        replacement.folders,
        type,
        workspace,
    ]);
    if (replacement.colors && replacement.colors.length > 0 && !!type) {
        if ((replacement.assets && replacement.assets.length > 0) ||
            (replacement.folders && replacement.folders.length > 0)) {
            const items = [
                {
                    content: assetReplacementPanel,
                    label: t(`tool.library.${type}`),
                },
                { content: colorReplacementPanel, label: colorReplacementTitle },
            ];
            return (0, jsx_runtime_1.jsx)(ui_common_components_1.Tabs, { items: items });
        }
        else {
            return colorReplacementPanel;
        }
    }
    if (replacement.colors && replacement.colors.length > 0) {
        return colorReplacementPanel;
    }
    if (type) {
        return assetReplacementPanel;
    }
    return ((0, jsx_runtime_1.jsxs)(Workspace_style_1.StyledEmptyFolder, { children: [(0, jsx_runtime_1.jsx)(Workspace_style_1.StyledEmptyFolderImage, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Icon, { name: theme.Components.Empty.Icon, size: "XXLarge" }) }), (0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "BodyLargeHeavy", color: theme.Color.Neutrals.Dark, children: noAssetsReplacement })] }));
}
exports.ReplacementPanel = ReplacementPanel;
//# sourceMappingURL=ReplacementContainer.js.map